<article class="flex flex-col gap-6 overflow-hidden rounded-3xl bg-lGray900 p-6">
  <header class="flex items-start justify-between gap-4">
    <div class="flex flex-col gap-1">
      <h2 class="text-xl font-bold text-color">{{ modalTitle }}</h2>
      <p class="text-sm subtext-color">{{ modalSubtitle }}</p>
    </div>

    <button
      type="button"
      class="p-1 text-lGray500 transition-colors hover:text-lGray300"
      aria-label="Fechar"
      (click)="close()"
    >
      <l-icon icon="close" class="text-2xl" />
    </button>
  </header>

  <form [formGroup]="formGroup" class="flex flex-col gap-6" (ngSubmit)="submit()">
    <div class="flex justify-center py-1">
      <img
        src="assets/icons/tags.svg"
        alt="Etiquetas representando tags de pesquisa"
        class="h-44 w-auto object-contain"
      />
    </div>

    <div class="flex flex-col gap-2">
      <label for="tagName" class="text-sm font-medium text-lGray500">
        Nome da tag <span class="text-lDanger">*</span>
      </label>

      <div class="relative">
        <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-xl text-lGray600" icon="sell" />
        <input
          id="tagName"
          lInput
          formControlName="name"
          placeholder="Ex.: Recursos Humanos"
          autocomplete="off"
          [maxlength]="nameMax"
          class="pl-11 border-none"
          [ngClass]="{ '!border !border-lDanger focus:!border-lDanger focus:!ring-lDanger': !!errorMessage }"
        />
      </div>

      <div class="flex items-start justify-between gap-4 text-xs">
        @if (errorMessage) {
          <span class="flex items-center gap-1 text-lDanger" role="alert">
            <l-icon icon="error" class="text-sm" />
            {{ errorMessage }}
          </span>
        } @else {
          <span class="flex items-center gap-1 text-lGray500">
            @if (isCheckingName) {
              <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
              Verificando disponibilidade do nome...
            } @else {
              <l-icon icon="info" class="text-sm" />
              O ID e as datas de criação e atualização são gerados automaticamente.
            }
          </span>
        }

        <span class="shrink-0 text-lGray500">{{ nameCount }} / {{ nameMax }}</span>
      </div>
    </div>

    <div class="text-xs text-lDanger">(*) Campos obrigatórios</div>
  </form>
</article>

<div class="flex justify-center pt-2 mt-5">
  <button
    lButton
    type="button"
    [bType]="isDisabled ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
    [bSize]="buttonSizeEnum.MEDIUM"
    [bRadius]="buttonRadiusEnum.LARGE"
    [disabled]="isDisabled"
    class="min-w-50"
    (click)="submit()"
  >
    @if (isSubmitting) {
      <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
    }

    {{ submitLabel }}
  </button>
</div>
